import { render, staticRenderFns } from "./DailyDetail.vue?vue&type=template&id=65ee0620&scoped=true"
import script from "./DailyDetail.vue?vue&type=script&lang=js"
export * from "./DailyDetail.vue?vue&type=script&lang=js"
import style0 from "./DailyDetail.vue?vue&type=style&index=0&id=65ee0620&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee0620",
  null
  
)

export default component.exports